import * as actionTypes from '../actions/actionTypes';

const initialState = {
  summary: null,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ENREGISTRER_ACCUEIL_SUMMARY:
      return { ...state, summary: action.summary || null };
    case actionTypes.ENREGISTRER_DASHBOARD_FAVORI:
      return {
        ...state,
        summary: {
          ...state.summary,
          favorite_dashboards_list: action.favorite_dashboards_list,
        },
      };
    case actionTypes.ENREGISTRER_GRAPHE_FAVORI:
      return {
        ...state,
        summary: {
          ...state.summary,
          favorite_graphs_list: action.favorite_graphs_list,
        },
      };
    case actionTypes.ENREGISTRER_PLAN_FAVORI:
      return {
        ...state,
        summary: {
          ...state.summary,
          favorite_views_list: action.favorite_views_list,
        },
      };
    case actionTypes.CHARGEMENT_ACCUEIL:
      return {
        ...state,
        loading: action.loading,
        ...(action.loading ? { summary: null } : {}),
      };
    default:
      return state;
  }
};

export default reducer;
